import { Card, CardHeader, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import MaterialButton from "../../../components/MaterialButton";
import MaterialTypography from "../../../components/MaterialTypography";
import AddIcon from "@mui/icons-material/Add";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Swal from "sweetalert2";
import _ from "lodash";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import { allBrands } from "./brandData";
import URL from "../../../pages/Utils/url";
import PageLoading from "../../../components/Loading/PageLoading";
import RoleAccess from "../../function/RoleAccess";

const BrandList = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchdata();
  }, []);

  const BrandListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Brand Name",
        field: "brandName",
        name: "brandName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Brand Code",
        field: "brandCode",
        name: "brandCode",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Brand Description",
        field: "brandDescription",
        name: "brandDescription",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Create By",
        field: "createdBy",
        name: "createdBy",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Create Date",
        field: "createdAt",
        name: "createdAt",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Action",
        field: "Action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: data.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      brandCode: v?.brandCode,
      brandName: _.capitalize(v?.brandName),
      brandDescription: v?.brandDescription
        ? _.capitalize(v?.brandDescription)
        : "N/A",
      createdBy: v?.user?.employeeName,
      createdAt: v?.createdAt?.slice(0, 10),

      Action: (
        <div
          style={{
            display: "flex",
            marginTop: "10px",
            alignItems: "center",
          }}
        >
          <RoleAccess modelName="Brand Screen" component="ViewBrand">
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/brand/view-brand`, {
                  state: { type: "view", data: v },
                })
              }
            />
          </RoleAccess>
          <RoleAccess modelName="Brand Screen" component="UpdateBrand">
            <EditIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/brand/edit-brand`, {
                  state: { type: "edit", data: v },
                })
              }
            />
          </RoleAccess>
        </div>
      ),
    })),
  };
  const fetchdata = () => {
    setIsLoading(true);
    request(BASEURL, allBrands)
      .then((res) => {
        const success = res?.allBrands?.success;
      

        const message = res?.allBrands?.message;
        if (success) {
          const newdata = res?.allBrands?.data?.map((val) => ({
            ...val,
            brandLogo: val?.brandLogo ? `${URL}media/${val?.brandLogo}` : null,
          }));
          setData(newdata);
        } else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: message,
            showConfirmButton: true,
          });
          setData([]);
        }
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Brand List
                </MaterialTypography>
              </Stack>
              <RoleAccess modelName="Brand Screen" component="CreateBrand">
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    navigate("/brand/add-brand", { state: { type: "add" } })
                  }
                >
                  Brand
                </MaterialButton>
              </RoleAccess>
            </Stack>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            rows={BrandListTable?.rows}
            columns={BrandListTable?.columns}
            isSelectable={false}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No Brand found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet add any brand details. Click on the "Add
                    Brand" button to start adding brand details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        )}

        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
};

export default BrandList;
